export default __webpack_public_path__ + "media/images/landing-13-550x420-58aafb3406937dc031d87cd237be32cd.jpg";